import { Font } from "./api"
import theme from "./themes"

export const fontSelect = (fonts: Font[], font: number, defaultFont: number = 2) => {
    if (fonts.length <= 0) {
        return {}
    }
    let style: any = {}
    if (fonts[font - 1] && fonts[font - 1].aktywna !== 0) {
        style = fonts[font - 1]
    } else if (fonts[defaultFont - 1] && fonts[defaultFont - 1].aktywna !== 0) {
        style = fonts[defaultFont - 1]
    } else {
        return {}
    }
    return {
        fontSize: `${style.fontSize}px`,
        fontWeight: style.fontWeight,
        color: style.color,
        fontFamily: style.fontFamily + "," + theme.typography.fontFamily,
    }
}
